<template>
  <div id="app">
    
    <router-view/>
  </div>
</template>


<script>
export default {

  created(){
    
    // var width = document.body.clientWidth;

    // if(width<800){
    //   this.$router.push("/mobile")
    // }else {
    //   this.$router.push("/pc")
    // }

  }

}
</script>


<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>
